import React, { useCallback, useRef, useState, useEffect } from 'react'
import { SLowcodeList, STableActions, SActionBtn } from 'shj-components'
import { Button, Col, DatePicker, Row, Table, Tabs, Spin } from 'antd'
import { cloneDeep, get } from 'lodash-es'
import QuickDateSelector from '@/components/QuickDateSelector'
import CustomSearchItem from '@/components/CustomSearchItem'
import { getUser, getMenuList, dfs, navigatePage } from '@/common/utils'
import styles from '../../index.module.less'
import { useNavigate } from 'react-router-dom'
import { galleryGetData } from '@/services/homeService'

const { RangePicker } = DatePicker

const dataBoard = (props: any) => {
  const navigate = useNavigate()
  const [currentDateKey, setCurrentDateKey] = useState('THIS_MONTH')
  const [isDateDisable, setIsDateDisable] = useState(true)
  const [loading, setLoading] = useState(false)
  const [dataList, setDataList] = useState([])
  const [dateTitle, setDateTitle] = useState('')
  // const [dateValues, setDateValues] = useState({})
  const dateValues = useRef<any>({
    dateType: 'THIS_MONTH',
  })
  const [userName, setUserName] = useState('')
  useEffect(() => {
    const userInfo = getUser()
    setUserName(userInfo?.alias)

    var now = new Date()
    var hour = now.getHours()
    if (hour < 12) {
      setDateTitle('上午好！')
    } else if (hour >= 12 && hour <= 17) {
      setDateTitle('下午好！')
    } else {
      setDateTitle('晚上好！')
    }
    initFn()
    return () => {}
  }, [])

  const initFn = () => {
    setLoading(true)
    galleryGetData({
      ...dateValues.current,
    })
      .then(res => {
        let data = cloneDeep(res)
        data.map((item, index) => {
          item.num = item.value ? (item.dig ? item.value.toFixed(item.dig) : item.value) : 0
          item.num = item.append ? item.num + item.append : item.num
        })
        setDataList(data)
        setLoading(false)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const quickDateChange = (key: string) => {
    if (key == 'custom') {
      setIsDateDisable(false)
      dateValues.current.dateType = undefined
    } else {
      setIsDateDisable(true)
      dateValues.current.beginDate = undefined
      dateValues.current.endDate = undefined
      dateValues.current.dateType = key
      initFn()
    }
    setCurrentDateKey(key)
  }

  const dateChange = (value: any) => {
    dateValues.current.beginDate = value?.[0].format('YYYY-MM-DD HH:mm:ss')
    dateValues.current.endDate = value?.[1].format('YYYY-MM-DD HH:mm:ss')
    initFn()
  }

  const goToPage = () => {
    const list = JSON.parse(getMenuList())
    console.log(list)
    let data = ''
    dfs(list, (item: any, index: any) => {
      if (item.children && item.appPath === '/marketing') {
        item.children.map((eve, i) => {
          data = eve
        })
      }
    })
    navigatePage(data.appPath, data.path, navigate)
  }

  return (
    <Spin spinning={loading}>
      <div
        style={{ backgroundColor: '#fff', height: '150px', width: '100%', marginBottom: '10px' }}
      >
        {dataList && dataList.length > 0 ? (
          <div className={styles.deliveryOperation}>
            <div className={styles.titleCon}>
              <div className={styles.titleText}>数据看板</div>
              <div className={styles.selectCon}>
                {currentDateKey === 'custom' ? (
                  <CustomSearchItem
                    labelTitle={'时间区间'}
                    customStyle={{ width: '410px', marginLeft: '15px' }}
                  >
                    <RangePicker onChange={dateChange} disabled={isDateDisable} showTime={true} />
                  </CustomSearchItem>
                ) : null}
                <div>
                  <QuickDateSelector onChange={(key: string) => quickDateChange(key)} />
                </div>
                <img
                  src={require('@/assets/Reset.png')}
                  style={{ marginLeft: '10px' }}
                  onClick={() => {
                    initFn()
                  }}
                />
              </div>
            </div>
            <div className={styles.contentCon}>
              <Row>
                {dataList.map((item, index) => {
                  return (
                    <Col span={6} className={styles.boardContent} key={index}>
                      <img
                        src={`https://static.shjmall.cn/sass/dataBoard${index + 1}.png`}
                        className={styles.dataBoardImg}
                      />
                      <div className={styles.dataValueContent}>
                        <div className={styles.dataValue}>{item.num}</div>
                        <div className={styles.dataValueTitle}>{item.name}</div>
                      </div>
                    </Col>
                  )
                })}
              </Row>
            </div>
          </div>
        ) : (
          <div className={styles.welcomePage}>
            <div className={styles.welcomeContent}>
              <div className={styles.userName}>
                {userName}
                {'，'}
                {dateTitle}
              </div>
              <div className={styles.welcomeTitle}>欢迎使用生活家数智整装SaaS服务系统</div>
              <div className={styles.welcomeBtn} onClick={goToPage}>
                去看看
              </div>
            </div>
          </div>
        )}
      </div>
    </Spin>
  )
}
export default dataBoard
